
import http from '../../HttpService'
import axios from '../../../axios'

// ? API etrange verifié l'utilité ?

const dataType = `user_password`
const baseService = http(dataType)
const additionalRequest = {
    post: () => new Error('not avaivable'),
    put: () => new Error('not avaivable'),
    delete: () => new Error('not avaivable'),
    update: (params: any) => axios.post(`${dataType}/update`, params)

}

export default Object.assign(baseService, additionalRequest)
